export const MSSF_003_fikk_ikke_svar_fra_apikall = 'MSSF-003';
export const MSSF_004_svar_fra_api_kall_uten_kode = 'MSSF-004';
export const MSSF_006_klarte_ikke_parse_json = 'MSSF-006';
export const MSSF_007_sesjon_utgikk = 'MSSF-007';
export const MSSF_011_programmeringsfeil_browser = 'MSSF-011';
export const MSSF_012_blokkert_av_big_ip = 'MSSF-012';
export const MSSF_013_mangler_intl_id = 'MSSF-013';
export const CONFLICT_HTTP_409 = 'CONFLICT_HTTP_409';
